<template>
    <div class="pp-sec">

        <div class="pp-sec-label" v-if="section.label">{{ section.label }}</div>
        <div class="pp-sec-title" v-html="section.title_html"></div>

        <!-- Summary -->
        <div class="pp-rev-summary" v-if="summary.rating && summary.count">
            <div class="pp-rev-big">
                <div class="pp-rev-big-num">{{ summary.rating }}</div>
                <div class="pp-rev-big-stars">{{ stars(summary.rating) }}</div>
                <div class="pp-rev-big-count">{{ summary.count }} reviews</div>
            </div>
            <div class="pp-rev-bars" v-if="summary.distribution">
                <div class="pp-rev-bar-row" v-for="s in [5,4,3,2,1]" :key="s">
                    <span class="pp-rev-bar-label">{{ s }}★</span>
                    <div class="pp-rev-bar-track">
                        <div class="pp-rev-bar-fill" :style="{ width: (summary.distribution[s] || 0) + '%' }"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- States -->
        <div class="pp-rev-loading" v-if="loading && !items.length">Loading reviews…</div>
        <div class="pp-rev-empty"   v-if="!loading && !items.length && loaded">No reviews yet.</div>

        <!-- List -->
        <div class="pp-review-list" v-if="items.length">
            <transition-group name="pp-review" tag="div">
                <div class="pp-review-card" v-for="review in items" :key="review.id">
                    <div class="pp-review-top">
                        <div class="pp-review-avatar">{{ initial(review.name) }}</div>
                        <div>
                            <div class="pp-review-name">
                                {{ review.name }}
                                <span class="pp-review-verified" v-if="review.verified">✓ Verified</span>
                            </div>
                        </div>
                        <div class="pp-review-stars">{{ stars(review.rating) }}</div>
                    </div>
                    <div class="pp-review-tag"   v-if="review.tag">{{ review.tag }}</div>
                    <div class="pp-review-title" v-if="review.title"><strong>{{ review.title }}</strong></div>
                    <div class="pp-review-text"  v-if="review.text">{{ review.text }}</div>
                    <div class="pp-review-date"  v-if="review.review_date">{{ formatDate(review.review_date) }}</div>
                </div>
            </transition-group>
        </div>

        <!-- Load more -->
        <div class="pp-rev-more" v-if="hasMore">
            <button @click="loadMore" :disabled="loading">
                {{ loading ? 'Loading…' : 'Load more reviews' }}
            </button>
        </div>

    </div>
</template>

<script>
export default {
    name: 'Reviews',

    props: {
        section:   { type: Object, required: true },
        productId: { type: Number, required: true },
    },

    data() {
        return {
            items:   [],
            page:    1,
            pages:   1,
            loading: false,
            loaded:  false,
        };
    },

    computed: {

        hasMore() {
            return this.page < this.pages;
        },

        summary() {
            const s = this.section?.summary;
            if ( !s?.rating || !s?.count ) return {};
            return s;
        },
    },

    mounted() {
        this.load();
    },

    methods: {

        async load() {

            if ( this.loading ) return;
            this.loading = true;

            try {
                const response  =  await this.$http.post( '/reviews/list', {
                    product_id: this.productId,
                    page:       this.page,
                    limit:      10,
                } );

                const { status, data } = response?.data || {};

                if ( status === 'success' ) {
                    this.items = [ ...this.items, ...( data.items || [] ) ];
                    this.pages = data.pages || 1;
                }

            } catch ( e ) {
                console.error( 'Reviews error:', e );
            } finally {
                this.loading = false;
                this.loaded  = true;
            }
        },

        loadMore() {
            this.page++;
            this.load();
        },

        initial( name ) {
            return ( name || '?' ).charAt( 0 ).toUpperCase();
        },

        stars( rating ) {
            const n = Math.round( rating || 0 );
            return '★'.repeat( n ) + '☆'.repeat( Math.max( 0, 5 - n ) );
        },

        formatDate( d ) {
            if ( !d ) return '';
            return new Date( d ).toLocaleDateString( 'en-US', {
                month: 'short', day: 'numeric', year: 'numeric',
            } );
        },
    },
};
</script>